import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';

function CutomModal(props) {
    return (
        <Modal 
            size="xl"
            show={props.isModalVisible}
        >
            <Modal.Header style={{ backgroundColor: "#be1e2d" }} >
                <Modal.Title
                    style={{ color: "white" }}
                >
                    <h3>{props.modalTitle}</h3>
                </Modal.Title>
                <Button variant="link" className="modalClosigButton"
                    onClick={() => { props.handleModalClose() }}>×</Button>
            </Modal.Header>
            <Modal.Body style={{ height: 600, overflow: "scroll" }}>
                {props.Compname === "TermsAndConditions" ? <TermsAndConditions /> : <PrivacyPolicy />}
            </Modal.Body>
            {props.footer &&
            <Modal.Footer className='bg-dark'>
                
                <props.footer/>
            </Modal.Footer>}
        </Modal>
    );
}

export default CutomModal;